import type { JSX, ChangeEvent, ReactNode } from "react";

import { OptionContainer } from "app/components/SharingModal/components/OptionContainer/OptionContainer";
import { Container, OptionsTitle } from "./SharingOptionsContainer.styled";
import { InviteTeammatesNotification } from "app/components/SharingModal/components/InviteTeammatesNotification/InviteTeammatesNotification";
import type {
    ISharingModalState,
    ISharingModalOptionsText,
    ISharingModalOnSubmit,
} from "app/components/SharingModal/types";
import { ISharingModalOption } from "app/components/SharingModal/types";
import { translate } from "app/filters/i18nFilter";

interface ISharingOptionsContainerProps<T> {
    text: ISharingModalOptionsText;
    sharing: ISharingModalState;
    onShare: ISharingModalOnSubmit;
    isRestrictedOptionDisabled: boolean;
    isSharedOptionDisabled: boolean;
    users: T[];
    isSharingView: boolean;
    onChangeNotification: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    inviteUsersComponent?: ReactNode;
}

export const SharingOptionsContainer = <T,>({
    text,
    sharing,
    onShare,
    isRestrictedOptionDisabled,
    isSharedOptionDisabled,
    users,
    isSharingView,
    onChangeNotification,
    inviteUsersComponent,
}: ISharingOptionsContainerProps<T>): JSX.Element => {
    const { sharingState, sharedWithUsers, notification, sharedWithUsersToShow, sharedWithInvitations } = sharing;

    return (
        <Container>
            {inviteUsersComponent}
            {isSharingView ? (
                <InviteTeammatesNotification
                    notification={notification}
                    onChangeNotification={onChangeNotification}
                />
            ) : (
                <>
                    <OptionsTitle>{translate("dashboard.shareDashboard.modal.optionsTitle")}</OptionsTitle>
                    <OptionContainer
                        sharing={sharing}
                        sharingState={sharingState}
                        textContainer={text[ISharingModalOption.SHARED]}
                        isOptionDisabled={isSharedOptionDisabled}
                        sharedWithUsers={sharedWithUsers}
                        onShare={onShare}
                        sharedWithUsersToShow={sharedWithUsersToShow}
                        sharedWithInvitations={sharedWithInvitations}
                        users={users}
                    />
                    <OptionContainer
                        sharing={sharing}
                        sharingState={sharingState}
                        textContainer={text[ISharingModalOption.RESTRICTED]}
                        isOptionDisabled={isRestrictedOptionDisabled}
                        sharedWithUsers={sharedWithUsers}
                        onShare={onShare}
                        sharedWithUsersToShow={sharedWithUsersToShow}
                        sharedWithInvitations={sharedWithInvitations}
                        users={users}
                        hasSharedUsersList={true}
                    />
                </>
            )}
        </Container>
    );
};
